const BannerPrenotazioni = () => {
    const banner = document.querySelector('.banner-prenotazioni:not(.--referti,.--nojs)');
    if(banner) {
        const bannerHead = banner.querySelector('.banner-prenotazioni__head');
        if(bannerHead) {
            bannerHead.addEventListener('click', () => {
                banner.classList.toggle('--opened');
            })
        }
    }
}

export default BannerPrenotazioni